import Model, { attr } from '@ember-data/model';

import CURRENCIES from '../constants/currencies';

export default class ReceivableCreditNoteModel extends Model {
  @attr amountDue;
  @attr issueDate;
  @attr locale;
  @attr number;
  @attr subtotal;
  @attr termsAndConditions;
  @attr pdfUrl;
  @attr vatAmount;
  @attr contactEmail;
  @attr reason;
  @attr('hash') originalInvoice;
  @attr('hash') items;
  @attr('hash') organization;
  @attr() welfareFundAmount;
  @attr() withholdingTaxAmount;
  @attr() stampDutyAmount;
  @attr('string', { defaultValue: CURRENCIES.default }) currency;
  //Used to display the pdf in the iframe
  @attr pdfSrc;

  get totalAmount() {
    return this.amountDue;
  }

  get totalExcludingVat() {
    return this.subtotal;
  }

  get totalVat() {
    return this.vatAmount;
  }

  async setPdfSrc() {
    if (!this.pdfUrl) return;
    let reader = new FileReader();
    let handler = () => {
      this.pdfSrc = reader.result;
    };

    try {
      let response = await fetch(this.pdfUrl, { method: 'GET' });
      let blob = await response.blob();

      reader.addEventListener('load', handler);
      reader.readAsDataURL(blob);
    } catch {
      this.pdfSrc = null;
    } finally {
      reader.removeEventListener(handler);
    }
  }
}
